/** Annotations bottom padding in pixels */
export const ANNOTATIONS_PADDING_BOTTOM = 6;
